import pako from "pako";

//TOOD:当数据过大时可能栈溢出, 和btoa或是fromCharCode无关? 此时只能先选择不压缩
export const compressString = (originalString: any) => {
  if (originalString == null || originalString === undefined) return null;
  const utf8Data = new TextEncoder().encode(JSON.stringify(originalString));
  const compressedData = pako.deflate(utf8Data);
  const compressedArray = Array.from(compressedData);
  // 可gzip解压获取原文
  // 使用 btoa 将将数组转换为字符串,
  // const compressedString = btoa(
  //   String.fromCharCode.apply(null, compressedArray)
  // );
  // 将数组直接转换为字符串(副作用:防止破解)
  const compressedString = String.fromCharCode(...compressedArray);
  return compressedString;
};

export const decompressString = (compressedString: String) => {
  if (compressedString == null || compressedString === undefined) return null;
  // 可gzip解压获取原文
  // const compressedArray = atob(compressedString)
  //   .split("")
  //   .map((c) => c.charCodeAt(0));
  // 将字符串转换为数组(副作用:防止破解)
  const compressedArray = compressedString
    .split("")
    .map((c) => c.charCodeAt(0));
  const compressedData = new Uint8Array(compressedArray);
  const decompressedData = pako.inflate(compressedData);
  const decompressedString = new TextDecoder().decode(decompressedData);
  return JSON.parse(decompressedString);
};
